<template>
    <o-dialog
        title="Advanced Dialog"
        content="Some quick example text to build on the dialog title and make up the bulk of the dialog's content."
        image-alt="Oruga Logo"
        image-src="https://avatars2.githubusercontent.com/u/66300512?s=200&v=4" />
</template>
